import { RadioGroup } from '@radix-ui/react-radio-group';
import Card from '@/components/ui/Card';
import usePaymentDetails from '@/store/paymentDetailsStore';
import Flex from '@/components/ui/Flex';
import Icon from '@/assets/icons/Icon';
import { RadioGroupItem } from '@/components/ui/RadioGroup';

export default function PaymentMethodRadio() {
  const { paymentMethod, setPaymentMethod } = usePaymentDetails();
  return (
    <Card className="p-0">
      <RadioGroup
        value={paymentMethod}
        onValueChange={setPaymentMethod}
        className="gap-0"
      >
        <PaymentMethodItem
          value="stripe"
          activeValue={paymentMethod}
          left={
            <>
              <span className="text-sm font-semibold">Credit card</span>
              <Icon.Stripe />
            </>
          }
          right={
            <Flex.Row className="gap-2">
              <Icon.CardVisa />
              <Icon.CardMastercard />
              <Icon.CardAmex />
            </Flex.Row>
          }
        />
        <div className="border-t border-neutral-200"></div>
        <PaymentMethodItem
          value="cryptomus"
          activeValue={paymentMethod}
          left={<span className="text-sm font-semibold">Crypto</span>}
          right={
            <Flex.Row className="gap-2 items-center">
              <Icon.CurrencyBitcoin />
              <Icon.CurrencyTether />
              <Icon.CurrencyLitecoin />
              <span className="text-sm font-semibold text-gray-600">
                + over 70
              </span>
            </Flex.Row>
          }
        />
      </RadioGroup>
    </Card>
  );
}

function PaymentMethodItem({
  value,
  activeValue,
  left,
  right,
}: {
  value: string;
  activeValue: string;
  left: React.ReactNode;
  right: React.ReactNode;
}) {
  return (
    <label
      className={`flex flex-row gap-2 items-center p-4 justify-between center cursor-pointer ${
        activeValue === value ? 'bg-indigo-600/5' : ''
      }`}
    >
      <Flex.Row className="gap-2 items-center">
        <RadioGroupItem value={value} />
        {left}
      </Flex.Row>
      {right}
    </label>
  );
}
